import { xmlToJson } from './xmlUtils';

export const parseAutofillData = (data, name) => {
  if (data == null) {
    return null;
  }

  const autofillData = xmlToJson(data);
  return autofillData[Object.keys(autofillData)[0]].value.map(a => {
    const AUTOFILL_REGEX = new RegExp(/\{(txt|img|mov):([^}]+)\}/ig);
    let autofillItem;
    const autofillOptions = {};
    let index = 0;
    do {
      autofillItem = AUTOFILL_REGEX.exec(a);
      if (autofillItem) {
        autofillOptions[`${name}${index > 0 ? `-${index}` : ''}`] = {
          type: autofillItem[1],
          value: autofillItem[2]
        };
      }
      index += 1;
    } while (autofillItem);

    return autofillOptions;
  });
};

export const getDefaultAutofillOptions = (replaceables) => {
  const autofillDefaultOptions = {};
  const autofillKeys = replaceables.filter(r => r.properties['data list xpath']).map(r => r.name);
  for (let i = 0; i < autofillKeys.length; i++) {
    const autofillOptions = {};
    const replaceableGroup = replaceables.filter(r => r.name.includes(autofillKeys[i]));
    for (let j = 0; j < replaceableGroup.length; j++) {
      autofillOptions[replaceableGroup[j].name] = {
        type: replaceableGroup[j].type === 'text' ? 'txt' : 'img',
        value: replaceableGroup[j].value
      };
    }
    autofillDefaultOptions[autofillKeys[i]] = autofillOptions;
  }
  return autofillDefaultOptions;
};

export const generateDefaultEmptyAutofillOption = (replaceables, autofillKey) => {
  const autofillOptions = {};
  const replaceableGroup = replaceables.filter(r => r.name.includes(autofillKey));
  autofillOptions[replaceableGroup[0].name] = {
    type: replaceableGroup[0].type === 'text' ? 'txt' : 'img',
    value: ''
  };
  return autofillOptions;
};

export const getDefaultAutofillColumnOptions = (replaceables) => {
  const autofillDefaultOptions = {};
  const autofillReplaceables = replaceables.filter(r => r.properties.autofillDataColumnIndex === 0);

  autofillReplaceables.forEach(r => {
    const option = {
      type: r.type === 'text' ? 'txt' : 'img',
      value: r.value
    };

    autofillDefaultOptions[r.name] = {
      columns: [option]
    };
  });
  return autofillDefaultOptions;
};

export const isAutofillFillSelector = (replaceable) => {
  const autofillDataColumnIndex = replaceable.properties.autofillDataColumnIndex;
  let isSelector = autofillDataColumnIndex === 0;
  if (!isSelector && replaceable.properties['data list xpath']) {
    isSelector = !autofillDataColumnIndex || autofillDataColumnIndex === -1;
  }

  return isSelector;
};



// WEBPACK FOOTER //
// ./app/util/autofillUtils.js